import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { formatarDataApi } from 'src/app/util/date-format.util';
import { isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { ContaReceber } from './contareceber';
import { ContaReceberService } from 'src/app/service/contaReceber.service';

@Component({
  selector: 'app-conta-receber-consulta',
  templateUrl: './conta-receber-consulta.component.html',
  styleUrls: [
    './conta-receber.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class ContaReceberConsultaComponent {

  ordemColunasTabela = ['id', 'tipoPagador', 'pagadorDescricao', 'formaCobranca', 'parcela', 'total', 'atualizado', 'dtVencimento', 'dtPagamento', 'situacao', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: string[] = [];
  tipoFiltro = 'ID';
  tipoFiltros: string[] = ['ID', 'Vencimento', 'Recebimento', 'Pagador'];
  parametro = '';
  dataInicioFiltro: Date | null = null;
  dataFimFiltro: Date | null = null;
  contasReceber: ContaReceber[] = [];
  consultaRealizada = false;
  filtroSituacao: string | null = null;
  situacoesFiltro = [
    { valor: 'A_RECEBER', label: 'A Receber' },
    { valor: 'RECEBIDO', label: 'Recebido' },
    { valor: 'NEGOCIADO', label: 'Negociado' },
  ];

  constructor(
    private contaReceberService: ContaReceberService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  novo() {
    this.router.navigate(['/contaReceber/form']);
  }

  editar(id: number) {
    this.router.navigate(['/contaReceber/form', id]);
  }

  onFiltroChange() {
    this.consultaRealizada = false;
    this.contasReceber = [];
    this.totalElementos = 0;
    this.pagina = 0;
  }

  validarFiltros(): boolean {
    if (this.tipoFiltro === 'ID') {
      const termo = this.parametro?.trim();
      if (termo && !/^\d+$/.test(termo)) {
        this.snackBar.open('Informe um ID numérico válido.', 'ERRO', { duration: 2500 });
        return false;
      }
      return true;
    }
    if (this.tipoFiltro === 'Pagador') {
      if (!this.parametro?.trim()) {
        this.snackBar.open('Informe o pagador para consultar.', 'ERRO', { duration: 2500 });
        return false;
      }
      return true;
    }
    if (!this.dataInicioFiltro || !this.dataFimFiltro) {
      this.snackBar.open('Informe a data início e fim para consultar.', 'ERRO', { duration: 2500 });
      return false;
    }
    if (this.dataInicioFiltro.getTime() > this.dataFimFiltro.getTime()) {
      this.snackBar.open('A data início não pode ser maior que a data fim.', 'ERRO', { duration: 2500 });
      return false;
    }
    return true;
  }

  consultar(resetPagina = true) {
    if (!this.validarFiltros()) {
      return;
    }
    if (resetPagina) {
      this.pagina = 0;
    }

    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.contaReceberService.findClientById(idFiltro).subscribe((conta) => {
        this.contasReceber = [conta];
        this.totalElementos = 1;
        this.pagina = 0;
        this.consultaRealizada = true;
        this.mensagemErros = [];
      }, err => {
        this.mensagemErros = [err.error?.message ?? 'Conta não encontrada.'];
        this.snackBar.open(String(this.mensagemErros[0]), 'ERRO', { duration: 3000 });
      });
      return;
    }

    const dataInicio = this.tipoFiltro === 'Pagador' || this.tipoFiltro === 'ID'
      ? '01/01/2000'
      : formatarDataApi(this.dataInicioFiltro);
    const dataFim = this.tipoFiltro === 'Pagador' || this.tipoFiltro === 'ID'
      ? '01/01/3000'
      : formatarDataApi(this.dataFimFiltro);
    const pagador = this.tipoFiltro === 'Pagador' ? this.parametro.trim() : '';
    const tipoConsulta = this.tipoFiltro === 'ID' ? 'Vencimento' : this.tipoFiltro;

    this.contaReceberService.findContaReceber(
      this.pagina, this.tamanho, dataInicio, dataFim, tipoConsulta, pagador, this.filtroSituacao
    ).subscribe(response => {
      this.contasReceber = response.content ?? [];
      this.totalElementos = response.totalElements ?? 0;
      this.tamanho = response.size ?? this.tamanho;
      this.pagina = response.number ?? this.pagina;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, err => {
      this.mensagemErros = [err.error?.message ?? 'Erro ao consultar contas à receber.'];
      this.snackBar.open(this.mensagemErros[0], 'ERRO', { duration: 3000 });
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.excluir(id); }
    });
  }

  private excluir(id: number) {
    this.contaReceberService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Conta excluída com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + (errorResponse.error?.message ?? 'Falha ao excluir')];
    });
  }
}
